<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form -form-preload" :class="{ '-loading': loading }">

                <div class="c-loading__inner -search">
                    <div class="c-loading">
                        <svg class="c-loading__svg" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path class="c-loading__letters"
                                    d="M50.2,58.4c-0.6,0-1.7,0.1-3.1,0.2c-0.3,0-0.6,0-0.9,0.1l-1.8,7.4h5.9l2-7.9C51.5,58.3,50.8,58.4,50.2,58.4" />
                                <path class="c-loading__letters" d="M80.7,53.3c-1.2,0.4-2.5,0.8-4,1.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0,0.2,0,0.4,0,0.6
                                    c0,2.5-1.6,5.1-5.2,5.1c-2.4,0-4.7-1-6.8-3.1l-0.4-0.4l-0.1,0.6L61,62.7L61,62.9l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3
                                    c2.5,1.4,5.3,2.1,8.2,2.1c7.2,0,11-5.1,11-10.1C80.9,54.6,80.8,53.9,80.7,53.3" />
                            </g>
                            <circle class="c-loading__circle" cx="50" cy="50" r="40" stroke="url(#gradient)"
                                stroke-width="5" fill="none" />
                            <defs>
                                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" style="stop-color:#E40032;stop-opacity:1" />
                                    <stop offset="100%" style="stop-color:#ffffff;stop-opacity:1" />
                                </linearGradient>
                            </defs>
                            <g>
                                <path class="c-loading__letters"
                                    d="M40.8,38.1H23.2l-7.9,31.7h17.8l1.2-4.9H22.4l2.3-9.1h10.1l1.2-4.9H25.9l2-7.9h11.7L40.8,38.1z" />
                                <path class="c-loading__letters"
                                    d="M39.1,30.3c-0.7,0-1.4,0.4-2.7,1.1l-0.1,0.1L30,35.2l-0.9,0.5l1,0.1l1.4,0.1h0.1l0.1,0l7.1-2.2
                                    c0.8-0.2,1.6-0.5,1.9-1.4c0.1-0.4,0-0.8-0.2-1.2c-0.2-0.4-0.5-0.6-0.9-0.8C39.4,30.3,39.2,30.3,39.1,30.3" />
                                <path class="c-loading__letters" d="M43.3,34.5l-1.2,4.9H51l-0.2,0.8l-4,16.2c0.3,0,0.6,0,0.9-0.1c1-0.1,1.9-0.1,2.3-0.2c0.9-0.1,1.8-0.2,2.8-0.2
                                    l4.1-16.5h8.3l1-4.1l0.2-0.8L43.3,34.5L43.3,34.5z" />
                                <path class="c-loading__letters" d="M84.5,34.4c-2.9-1.7-5.7-2.1-7.5-2.1c-3,0-5.7,1-7.5,2.9c-1.7,1.7-2.6,4.1-2.6,6.5c0,2.8,1.2,4.8,2.7,6.4
                                    c0.7,0.8,1.5,1.5,2.2,2.1c0.7,0.6,1.3,1.3,1.9,2c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0,0.1,0c0.6-0.2,1.3-0.3,1.9-0.5
                                    c1.4-0.4,2.7-0.7,3.8-1.1c-0.3-0.6-0.7-1.1-1.1-1.6c-0.6-0.7-1.2-1.3-1.7-1.9l0,0l-0.9-0.9c-0.5-0.4-1-0.9-1.5-1.4
                                    c-1-1.1-1.9-2.4-1.9-3.9c0-2.1,1.6-4.4,4.6-4.4c1.1,0,3.3,0.3,5.6,2.5l0.4,0.4l0.1-0.5l1.1-4.5l0-0.1l0.1-0.2L84.5,34.4L84.5,34.4z
                                    " />
                            </g>
                        </svg>
                    </div>
                </div>

                <h2 class="o-title-4" v-if="prof == 0">
                    {{ t("Trouver un membre du personnel de l’ÉTS") }}
                </h2>
                <div class="o-form__item__container">
                    <div v-if="prof == 0" class="o-form__item">
                        <label class="o-label" for="bottin-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="bottin-search" type="text"
                            :placeholder='t("Nom, prénom, téléphone, poste, local")' v-model="searchInput">
                    </div>
                    <div v-else class="o-form__item">
                        <label class="o-label sr-only" for="bottin-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="bottin-search" type="text"
                            :placeholder='t("Mots clés")' v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#search"></use>
                        </svg>
                    </div>
                    <div v-if="departements.length && prof == 0" class="o-form__item">
                        <label class="o-label" for="departements">{{ t("Département") }}</label>
                        <div class="o-form__item">
                            <select @change="changeSelectionDepartement()" class="o-select" id="departements"
                                v-model="selectedDepartement">
                                <option value="">{{ t("Veuillez choisir un département") }}</option>
                                <option v-for="departement in departements" :value="departement">{{ departement }}
                                </option>
                            </select>
                            <svg class="o-ico -ico-arrow-down" role="img">
                                <title>arrow-down</title>
                                <use xlink:href="/assets/img/sprite.svg?v=5#arrow-down"></use>
                            </svg>
                        </div>
                    </div>
                    <div v-else-if="departements.length" class="o-form__item">
                        <label class="o-label sr-only" for="departements">{{ t("Département") }}</label>
                        <select @change="changeSelectionDepartement()" class="o-select" id="departements"
                            v-model="selectedDepartement">
                            <option value="">{{ t("Département") }}</option>
                            <option v-for="departement in departements" :value="departement">{{ departement }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#arrow-down"></use>
                        </svg>
                    </div>
                    <div v-if="axes.length" class="o-form__item">
                        <label class="o-label sr-only" for="axes">{{ t("Axe de recherche") }}</label>
                        <select @change="changeSelectionAxe()" class="o-select" id="axes" v-model="selectedAxe">
                            <option value="">{{ t("Axe de recherche") }}</option>
                            <option v-for="axe in axes" :value="axe">{{ axe }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=5#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__button c-tooltip__wrap">
                        <button v-if="target" @click.prevent="refreshUrlQuery()" class="o-button -button-bg"
                            type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=5#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=5#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }}
                                    <span v-if="!prof" class="sr-only">
                                        {{ t("une personne selon les critères sélectionnés") }}
                                    </span>
                                    <span v-else class="sr-only">
                                        {{ t("un professeur selon les critères sélectionnés") }}
                                    </span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span v-if="!target" class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{
                                    filteredResults.length > 1 ? 's' : '' }}
                            </span>
                            <span v-else class="c-tooltip__text">
                                {{ t("Voir les") }} {{ t("résultats") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="c-search-filters-results" :class="{ '-loading': loading }">
    <!-- <div class="c-search-filters-results" :class="{ '-loading': loading, '-noresults': filteredResults.length === 0 }"> -->
        <div v-if="filteredResults.length || tags.length || searchInput.length >= 3 || selectedAxes.length || selectedDepartements.length"
            class="c-programmes-search__filters">
            <div class="o-container">
                <div class="c-programmes-search__filters__wrap">
                    <div v-if="!target && (searchInput.length >= 3 || selectedAxes.length > 0 || selectedDepartements.length > 0)"
                        class="c-programmes-search__filters__total">
                        <span>
                            {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                        </span>
                    </div>
                    <div v-if="tags.length" class="c-programmes-search__filters__actives">
                        <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                            <span>
                                {{ tag.title }}
                            </span>
                            <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                                <span></span>
                                <span></span>
                                <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="!target && (tags.length > 0 || searchInput.length >= 3)"
                        class="c-programmes-search__filters__reset">
                        <button @click.prevent="resetSearch()" class="o-button -button-reset">
                            {{ t("Réinitialiser la recherche") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div ref="resultsStart"></div>
        <div class="o-section__inner">
            <div class="o-container">
                <div class="c-projects-search__results">
                    <template v-for="entry in filteredResultsPaged">
                        <div class="c-search-results__item -show">
                            <div class="c-search-result__header">
                                <span class="c-search-result__title o-title-4">
                                    <template v-if="entry.url != '#'">
                                        <a :href="entry.url">{{ entry.title }}</a>
                                    </template>
                                    <template v-else>
                                        <span>{{ entry.title }}</span>
                                    </template>
                                </span>
                            </div>
                            <div v-if="prof == 0" class="o-text">
                                <template v-for="(titre, i) in entry.titres">
                                    <div class="c-search-results__title">
                                        <p v-if="titre.Departement != 'Secouriste'">
                                            {{ titre.Titre }}
                                        </p>
                                        <p>
                                            <strong>{{ titre.Departement }}</strong>
                                        </p>
                                    </div>
                                </template>
                                <hr>
                                <div class="c-search-results__infos">
                                    <template v-for="(titre, i) in entry.titres">
                                        <template v-if="titre.Departement != 'Secouriste'">
                                            <span class="c-search-results__infos__item" v-if="titre.Emplacement.length">
                                                <svg class="o-ico" role="img">
                                                    <title>pin</title>
                                                    <use xlink:href="/assets/img/sprite.svg?v=5#pin-sm"></use>
                                                </svg>
                                                {{ t("Bureau") }} {{ titre.Emplacement[0].Number }}
                                            </span>
                                            <span class="c-search-results__infos__item"
                                                v-if="titre['Téléphone'].length">
                                                <svg class="o-ico" role="img">
                                                    <title>phone</title>
                                                    <use xlink:href="/assets/img/sprite.svg?v=5#phone-sm"></use>
                                                </svg>
                                                {{ titre['Téléphone'][0].Number }} <span
                                                    v-if="titre['Téléphone'][0].Extension">#{{
                                                        titre['Téléphone'][0].Extension }}</span>
                                            </span>
                                        </template>
                                    </template>
                                    <span class="c-search-results__infos__item" v-if="entry.courriel">
                                        <svg class="o-ico" role="img">
                                            <title>mail</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=5#mail-sm"></use>
                                        </svg>
                                        <a :href="'mailto:' + entry.courriel">{{ entry.courriel }}</a>
                                    </span>
                                </div>
                            </div>
                            <div v-else class="c-search-result__desc o-text">
                                <template v-for="(titre, i) in entry.titres">
                                    <p v-if="titre.Departement != 'Secouriste'">
                                        <span>{{ titre.Titre }}<br></span>
                                        <span>{{ titre.Departement }}<br></span>
                                        <span v-if="titre['Téléphone'].length">{{ t("Téléphone") }}: {{
                                            titre['Téléphone'][0].Number }} <span
                                                v-if="titre['Téléphone'][0].Extension">#{{
                                                    titre['Téléphone'][0].Extension }}</span><br></span>
                                        <span v-if="titre.Emplacement.length">{{ t("Bureau") }}: {{
                                            titre.Emplacement[0].Number }}</span>
                                    </p>
                                    <p v-else>
                                        <span>{{ titre.Departement }}<br></span>
                                    </p>
                                    <br>
                                </template>
                                <p>
                                    <span v-if="entry.courriel">{{ t("Courriel") }}: <a
                                            :href="'mailto:' + entry.courriel">{{ entry.courriel
                                            }}</a></span>
                                </p>
                            </div>
                            <div class="c-search-result__tags" v-if="entry.axes.length">
                                <span v-for="axe in entry.axes" class="o-tag">
                                    <template v-if="axe">{{ axe.replace(/<[^>]*>?/gm, '') }}</template>
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
                <Pager v-if="pagerInfo.totalPages > 1" :pagerInfo="pagerInfo" @goToPage="goToPage" />
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';
import Pager from './Pager.vue';

export default {
    props: {
        background: {
            type: String,
            default: ''
        },
        prof: {
            type: Boolean,
            default: 0
        },
        canChangeUrl: {
            type: Boolean,
            default: true
        },
        target: {
            type: String,
            default: false
        }
    },
    components: {
        Pager
    },
    data() {
        return {
            siteId: 1,
            loading: false,
            searchInput: '',
            searchedIds: null,
            selectedAxe: '',
            selectedDepartement: '',
            selectedAxes: [],
            selectedDepartements: [],
            axes: [],
            departements: [],
            results: [],
            controller: null,
            pagerInfo: {
                currentPage: 1,
                totalPages: 1
            },
            languageUrl: '/'
        }
    },
    mounted() {
        //console.log('PROF', this.prof)
        let lang = document.documentElement.lang;
        if (lang === 'fr-CA') {
            this.siteId = 1;
        } else {
            this.siteId = 2;
            this.languageUrl = '/en/';
        }

        //load query params
        const currentUrl = new URL(window.location.href);
        const query = currentUrl.search;
        const urlParams = new URLSearchParams(query);
        if (urlParams.has('axes')) {
            this.selectedAxes = urlParams.get('axes').split(',');
        }
        if (urlParams.has('departements')) {
            this.selectedDepartements = urlParams.get('departements').split(',');
        }
        if (urlParams.has('s')) {
            this.searchInput = urlParams.get('s');
        }
        this.fetchAttributes();
        if (this.searchInput.length >= 3) this.search();
        //console.log(ProjectLocalisation["Mots clés"])
    },
    computed: {
        filteredResults() {
            let filtered = this.results;

            if (this.prof && this.searchInput.length < 3 && this.selectedAxes.length == 0 && this.selectedDepartements.length == 0) {
                this.pagerInfo.currentPage = 1;
                this.pagerInfo.totalPages = 1;
                return [];
            }

            if (this.searchedIds !== null && this.searchedIds.length > 0) {
                if (this.searchedIds.length === 0) return [];
                filtered = filtered.filter(entry => {
                    return this.searchedIds.includes(entry.id);
                });

                filtered.sort((a, b) => {
                    return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                });
            }

            if (this.selectedAxes.length) {
                filtered = filtered.filter(entry => {
                    return this.selectedAxes.some(axe => entry.axes.includes(axe));
                });
            }
            if (this.selectedDepartements.length) {
                filtered = filtered.filter(entry => {
                    //return this.selectedDepartements.some(departement => entry.departements.includes(departement));
                    return this.selectedDepartements.some(departement => {
                        return entry.titres.some(titre => titre.Departement == departement);
                    });
                });
            }

            this.pagerInfo.totalPages = Math.ceil(filtered.length / 12);
            this.pagerInfo.currentPage = 1;
            if (this.selectedDepartements.length && this.selectedDepartements[0] === 'Service des ressources humaines') {
                // Set entry with ID 392433 as the first element
                const entry = filtered.find(e => e.id === 392433);
                if (entry) {
                    filtered = [entry, ...filtered.filter(e => e.id !== 392433)];
                }
            }
            return filtered;
        },
        filteredResultsPaged() {
            return this.filteredResults.slice((this.pagerInfo.currentPage - 1) * 12, this.pagerInfo.currentPage * 12);
        },
        tags() {
            let tags = [];

            this.selectedAxes.forEach(axe => tags.push({ type: 'axe', title: axe }));
            this.selectedDepartements.forEach(departement => tags.push({ type: 'departement', title: departement }));
            return tags
        }
    },
    methods: {
        t(string) {
            return ProfLocalisation[string];
        },
        fetchAttributes() {
            this.loading = true;
            fetch(this.languageUrl + 'api/search/bottin-index?siteId=' + this.siteId + '&prof=' + this.prof, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.axes !== undefined) this.axes = data.axes;
                    if (data.departements !== undefined) this.departements = data.departements;
                    if (!this.target && data.results !== undefined) this.results = data.results;

                    this.pagerInfo.totalPages = Math.ceil(this.results.length / 12);
                    this.loading = false;
                })
        },
        goToPage(page) {
            setTimeout(() => {
                this.pagerInfo.currentPage = page;
                this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        },
        changeSelectionAxe() {
            let current = this.selectedAxe;
            if (current === '') return;
            if (!this.selectedAxes.includes(current)) {
                this.selectedAxes.push(current);
            }
            this.selectedAxe = '';
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        changeSelectionDepartement() {
            let current = this.selectedDepartement;
            if (current === '') return;
            if (!this.selectedDepartements.includes(current)) {
                this.selectedDepartements.push(current);
            }
            this.selectedDepartement = '';
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        removeTag(tag) {
            if (tag.type === 'axe') {
                this.selectedAxes = this.selectedAxes.filter(axe => axe !== tag.title);
            }
            if (tag.type === 'departement') {
                this.selectedDepartements = this.selectedDepartements.filter(departement => departement !== tag.title);
            }
            if (this.target) return;
            if (this.canChangeUrl && !this.target) this.refreshUrlQuery();
        },
        keyupSearch: debounce(function (e) {
            if (this.controller) this.controller.abort();
            if (this.searchInput.length >= 3) {
                if (this.target) return;
                this.search();
            } else {
                this.searchedIds = null;
            }
        }, 500),
        search() {
            if (this.target) return;
            this.loading = true;
            if (this.controller) {
                this.controller.abort();
            }

            this.controller = new AbortController();

            fetch(this.languageUrl + 'api/search/bottin?s=' + this.searchInput + '&siteId=' + this.siteId + '&prof=' + this.prof, {
                signal: this.controller.signal,
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    this.searchedIds = data;
                    this.loading = false;
                    if (this.canChangeUrl) this.refreshUrlQuery();
                })
                .catch(err => {
                    this.searchedIds = null;
                    this.searchInput = '';
                    this.loading = false;
                    if (this.canChangeUrl) this.refreshUrlQuery();
                });
        },
        refreshUrlQuery() {
            let query = '';
            if (this.selectedAxes.length > 0) {
                query += 'axes=' + this.selectedAxes.join(',') + '&';
            }
            if (this.selectedDepartements.length > 0) {
                query += 'departements=' + this.selectedDepartements.join(',') + '&';
            }
            if (this.searchInput) {
                query += 's=' + this.searchInput;
            }
            const currentUrl = new URL(window.location.href);
            let pathName = currentUrl.pathname;
            pathName = pathName.replace(/(p\d)/, '');
            let newUrl = currentUrl.origin + pathName + '?' + query;
            if (this.target) {
                newUrl = this.target + '?' + query;
                window.location.href = newUrl;
            }
            window.history.pushState({ path: newUrl }, '', newUrl);
        },
        resetSearch() {
            this.searchInput = '';
            this.searchedIds = null;
            this.selectedAxes = [];
            this.selectedDepartements = [];
            if (this.canChangeUrl) this.refreshUrlQuery();
        }
    },
}
</script>
